import createOneModuleInstance from '../helpers/createOneModuleInstance';
import * as youtube from '../modules/youtube';

const youtubeApi = createOneModuleInstance(youtube);

export default youtubeApi;
